<template>
  <div id="app" ref="app">
    <notificationBar v-if="$storage.getLoginState()" @notificationDetail="detailadndSign"></notificationBar>
    <!-- 报警 -->
    <notificationDetail v-if="notificationDetailShow" ref="detail"></notificationDetail>
    <!-- 签约 -->
    <singDataShow v-if="singDataShowShow" ref="Sign"></singDataShow>

    <paymentFlow v-if="paymentFlowShow" ref="paymentFlowShow"></paymentFlow>
    <rePlay v-if="rePlayShow"></rePlay>
    <router-view v-if="isRouterAlive" />
    <!--个人信息修改-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="dialogForm"
      title="个人信息"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
    >
      <div class="line"></div>
      <el-form :ref="ref" :model="formParam" :rules="formParamRules" label-width="128px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="账号类型" prop="type">
              <el-select size="small" v-model="formParam.type" disabled>
                <el-option
                  v-for="item in $storage.getSelectDict('accountType')"
                  :key="item.value"
                  :label="item.label "
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="真实姓名">
              <el-input size="small" v-model="formParam.realname"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="电话(账号)" prop="tel">
              <el-input size="small" v-model="formParam.tel" name="tel" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="昵称" prop="nickname">
              <el-input size="small" v-model="formParam.nickname" name="nickname"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="角色" prop="roles" size="small" style="width: 90%;">
            <el-select
              multiple
              size="small"
              v-model="formParam.roles"
              disabled
              style="width: 100%;"
            >
              <el-option
                v-for="item in roleList"
                :key="item.value"
                :label="item.label "
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="remark" size="small" style="width: 90%">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              v-model="formParam.remark"
              name="remark"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="formBtn">
        <el-button size="small" type="primary" @click="addOrEditSubmit()">确定</el-button>
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="dialogForm"
      title="修改密码"
      :visible.sync="dialogVisiblePsw"
      width="400px"
      :before-close="handleClosePsw"
    >
      <div class="line"></div>
      <el-form ref="password" :model="password" :rules="formParamRulesPsw" label-width="80px">
        <el-form-item label="原密码" prop="oldpassword">
          <el-input size="small" v-model="password.oldpassword" show-password style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input size="small" v-model="password.password" show-password style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password">
          <el-input
            size="small"
            v-model="password.confirmpassword"
            show-password
            style="width:200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="formBtn">
        <el-button size="small" type="primary" @click="editPswSubmit()">确定</el-button>
        <el-button size="small" @click="dialogVisiblePsw = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import notificationBar from "@/components/notification/notificationBar";
import notificationDetail from "@/components/notification/notificationDetail";
import singDataShow from "@/components/notification/singDataShow";
import paymentFlow from "@/views/mod_synergism_manage/paymentFlow";
import realPlay from "@/components/vueAliplayerV2/realPlay";
import rePlay from "@/components/vueAliplayerV2/rePlay";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  components: {
    notificationBar,
    notificationDetail,
    singDataShow,
    paymentFlow,
    realPlay,
    rePlay,
  },
  data() {
    return {
      password: {
        oldpassword: "", //原密码
        password: "", //新密码
        confirmpassword: "", // 确认新密码
      },
      isRouterAlive: true,
      notificationDetailShow: false,
      singDataShowShow: false,
      paymentFlowShow: false, //支付流水
      dialogVisible: false, //个人信息显隐控制
      dialogVisiblePsw: false, //修改密码显隐控制
      aliplayeShow: true, //是否显示视频播放
      rePlayShow: false, //显示历史视频播放
      ref: "from",
      formParam: {},
      roleList: [], //角色列表
      formParamDefault: {
        tel: "",
        id: "",
        realname: "",
        nickname: "",
        sessionkey: "",
        openid: "",
        remark: "",
        userId: "",
        type: "",
        roles: "",
      },
      formParamRules: {
        userId: [{ required: true, message: "请选择员工", trigger: "change" }],
        nickname: [{ required: true, message: "请填写昵称", trigger: "blur" }],
      },
      formParamRulesPsw: {
        oldpassword: [
          { required: true, message: "请填写原密码", trigger: "change" },
        ],
        password: [
          { required: true, message: "请填写新密码", trigger: "change" },
        ],
        confirmpassword: [
          { required: true, message: "请输入确认密码", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    //员工下拉框改变时
    userChange() {
      var that = this;
      var id = this.formParam.userId;
      this.userList.forEach((e) => {
        if (e.value == id) {
          that.formParam.realname = e.label;
        }
      });
    },
    handleClose(done) {
      done();
    },
    handleClosePsw(done) {
      done();
    },
    //创建websocket链接
    createWebsocket() {
      this.$WBT.initWs(api.websocketUrl, this);
    },
    //初始化
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    detailadndSign(param, data) {
      if (data == 111) {
        this.detail(param);
      } else {
        this.Sign(param);
      }
    },
    //查看报警消息詳情
    detail(param) {
      var that = this;
      this.notificationDetailShow = true;
      this.$nextTick(function () {
        that.$refs["detail"].setData(param);
      });
      let data = new FormData();
      data.append("id", param.id);
      this.$req.post(data, api.url_alarm_info_read, function (_r, _x) {
        if (_r.success == true) {
          if (_r.data) {
          }
        }
      });
    },
    //查看签约消息詳情
    Sign(param) {
      var that = this;
      this.singDataShowShow = true;
      this.$nextTick(function () {
        that.$refs["Sign"].setData(param);
      });
    },
    /**
     * 表单提交前的逻辑判断及赋值，根据 sendType 来判断是新增还是编辑  add表示新增edit 表示编辑
     */
    addOrEditSubmit() {
      var that = this;
      var param = this.$util.formData(
        this.formParam,
        this.formParamDefault,
        "roles"
      );
      var roles = "";
      this.formParam.roles.forEach(function (e) {
        roles += e + ",";
      });
      if (roles) roles = roles.substring(0, roles.length - 1);
      param.append("roles", roles);
      this.$util._formPost(
        true,
        that,
        this.ref,
        param,
        api.url_Account_update,
        function () {
          that.$util._notify.success("操作成功！");
          that.dialogVisible = false;
        }
      );
    },
    //显示用户信息窗口
    dialogVisibleShow(id) {
      this.formParam = this.$util.clone_str(this.formParamDefault);
      let that = this;
      that.$util._formPost(
        false,
        that,
        that.ref,
        {},
        api.url_role_list,
        function (_r) {
          if (_r.success) {
            _r.data.forEach((element) => {
              that.roleList.push({
                value: element.id,
                label: element.roleName,
              });
            });
						that.roleList.push({
						  value: "101002",
						  label: "租户管理员",
						});
						console.log(that.roleList)
            var param = new FormData();
            param.append("id", id);
            that.$util._formPost(
              false,
              that,
              that.ref,
              param,
              api.url_Account_list,
              function (_r) {
                if (_r.success) {
                  var data = _r.data[0];
                  for (let key in that.formParam) {
                    for (let k in data) {
                      if (key == k) {
                        that.formParam[key] = data[k];
                      }
                    }
                  }
                  that.formParam.roles = that.formParam.roles.split(",");
                  that.formParam.userId = that.formParam.userId.toString();
                  that.dialogVisible = true;
                }
              }
            );
          }
        }
      );
    },
    //密码修改弹窗
    dialogVisiblePswShow() { 
      this.password.oldpassword = "";
      this.password.password = "";
      this.password.confirmpassword = "";
      this.dialogVisiblePsw = true;
    },
    editPswSubmit() {
      var that = this;
      if (this.password.password != this.password.confirmpassword) {
        that.$util._notify.error("确认密码输入不一致！");
        return;
      }
      var param = new FormData();
      param.append("id", this.$storage.getUser().userId);
      param.append("oldpassword", this.password.oldpassword);
      param.append("password", this.password.password);
      this.$util._formPost(
        true,
        that,
        "password",
        param,
        api.url_Account_editPwd,
        function () {
          that.$util._notify.success("密码修改成功！");
          that.dialogVisiblePsw = false;
        }
      );
    },
    paymentShow(id, unitId) {
      this.paymentFlowShow = true;
      this.$nextTick(function () {
        setParam(id, unitId);
      });
    },
  },
  // 在页面加载时读取sessionStorage里的状态信息
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    var that = this;
    this.formParam = this.$util.clone_str(this.formParamDefault);
    this.$nextTick(function () {
      if (this.$storage.getLoginState()) {
        this.createWebsocket();
      }
      window["dialogVisibleShow"] = (row) => {
        that.dialogVisibleShow(row);
      };
      window["dialogVisiblePswShow"] = () => {
        that.dialogVisiblePswShow();
      };
      window["paymentShow"] = (id, unitId) => {
        that.paymentShow(id, unitId);
      };
    });
  },
};
</script>

<style lang="scss">
html {
  width: 100%;
  height: 100%;
}

body {
  width: 100%;
  height: 100%;
}

ul,
ol,
li {
  list-style: none;
}

#app {
  font-family: "PingFang SC", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: $themeColor url(../static/img/background.png) no-repeat;
  color: $fontColor;
  position: relative;
  width: 100%;
  height: 100%;
  float: left;
  overflow: hidden;
}

.relativeContainer {
  position: relative;
}

.absoluteContainer {
  position: absolute;
}

.percent100 {
  width: 100%;
  height: 100%;
}

.left {
  float: left;
}

.right {
  float: right;
}

/*滚动条样式*/
html ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}

html ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.4);
}

html ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(156, 183, 214, 0.97);
}

.over-hidden {
  overflow: hidden;
}

.ellipse {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.line {
  @include line;
}
</style>
<style lang='scss'>
.dialogForm {
  @include dialogForm;
}
// 全局的地图label样式

.amap-marker-label {
  border: 0 none;
  padding: 0;
  background-color: #fff;
  white-space: nowrap;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
  border-radius: 4px;
  div {
    position: relative;
    height: 38px;
    line-height: 38px;
    span {
      display: inline-block;
    }
    .span1 {
      padding: 0 3px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(37, 43, 58, 1);
      height: 100%;
    }
    .span2 {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      background-color: #167fff;
      color: #fff;
      width: 38px;
    }
    i {
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-right: 15px solid #fff;
      border-bottom: 5px solid transparent;
      // border-right-color: #fff;
      position: absolute;
      left: -15px;
      top: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue